// SHOWING ELEMENTS ON SCROLL
let windowHeight;

// ---------------------------
// COMMON
// ---------------------------
let wysiwygLazyLoad = document.querySelector('.wysiwyg-lazy-load');
let wysiwygLazyLoadAnimationRunner = true;

let mainInfoBlock = document.querySelector('.main-info-block');
let mainInfoBlockAnimationRunner = true;

let carsList = document.querySelector('.cars-container');
let carsListAnimationRunner = true;
// ---------------------------
// END COMMON
// ---------------------------

// ---------------------------
// ABOUT US
// ---------------------------
let aboutUsRows = document.querySelectorAll('.about-us-rows .single-about-us-row');
let aboutUsRowsRunners = [];
for (let i = 0; i < aboutUsRows.length; i++) {
    aboutUsRowsRunners.push(true)
}

let aboutUsMembers = document.querySelector('.about-us-members');
let aboutUsMembersAnimationRunner = true;
// ---------------------------
// END ABOUT US
// ---------------------------

// ---------------------------
// CONTACTS
// ---------------------------
let contactsColumns = document.querySelector('.contacts-columns');
let contactsColumnsAnimationRunner = true;

let contactsMaps = document.querySelector('.contacts-maps-container');
let contactsMapsAnimationRunner = true;
// ---------------------------
// END CONTACTS
// ---------------------------

// ---------------------------
// FAQ
// ---------------------------
let faqHeroPartners = document.querySelector('.hero-default-partners');
let faqHeroPartnersAnimationRunner = true;

let faq = document.querySelector('.faq-list-container');
let faqAnimationRunner = true;
// ---------------------------
// END FAQ
// ---------------------------

// ---------------------------
// HOME
// ---------------------------
let homeFilters = document.querySelector('.home-filters-wrapper');
let homeFiltersAnimationRunner = true;
// ---------------------------
// END HOME
// ---------------------------

// ---------------------------
// APPLICATION
// ---------------------------
let applicationMain = document.querySelector('.application-container');
let applicationMainAnimationRunner = true;

let applicationCells = document.querySelector('.application-content-cells');
let applicationCellsAnimationRunner = true;
// ---------------------------
// END APPLICATION
// ---------------------------

// ---------------------------
// SINGLE CAR
// ---------------------------
let singleCarDetails = document.querySelector('.single-car-details');
let singleCarDetailsAnimationRunner = true;

let singleCarAdditionalContent = document.querySelector('.single-car-additional-content');
let singleCarAdditionalContentAnimationRunner = true;

let singleCarButtons = document.querySelector('.single-car-buttons');
let singleCarButtonsAnimationRunner = true;

let singleCarCharacteristics = document.querySelector('.single-car-characteristics-wrapper');
let singleCarCharacteristicsAnimationRunner = true;

let singleCarCarousel = document.querySelector('.single-car-carousel');
let singleCarCarouselAnimationRunner = true;

let singleCarMarketInsight = document.querySelector('.single-car-market-insight');
let singleCarMarketInsightAnimationRunner = true;
// ---------------------------
// END SINGLE CAR
// ---------------------------

// ---------------------------
window.onscroll = function () {
    windowHeight = jQuery(window).height();

    // COMMON
    if (jQuery(wysiwygLazyLoad).length && wysiwygLazyLoadAnimationRunner === true) {
        let wysiwygLazyLoadPosition = wysiwygLazyLoad.getBoundingClientRect();
        let wysiwygLazyLoadTop = wysiwygLazyLoadPosition.top;
        if (windowHeight - wysiwygLazyLoadTop > 0) {
            jQuery(".wysiwyg-lazy-load").addClass("bottom-side-fade-in-small-delay");
            wysiwygLazyLoadAnimationRunner = false;
            setTimeout(function () {
                jQuery(".wysiwyg-lazy-load").removeClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            }, 2000);
        }
    }
    if (jQuery(mainInfoBlock).length && mainInfoBlockAnimationRunner === true) {
        let mainInfoBlockPosition = mainInfoBlock.getBoundingClientRect();
        let mainInfoBlockTop = mainInfoBlockPosition.top;
        if (windowHeight - mainInfoBlockTop > 0) {
            jQuery(mainInfoBlock).find(".main-info-block-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            jQuery(mainInfoBlock).find(".main-info-block-subtitle").addClass("bottom-side-fade-in").removeClass("before-fade-in");
            jQuery(mainInfoBlock).find(".main-info-block-points").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            jQuery(mainInfoBlock).find(".main-info-block-button").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            mainInfoBlockAnimationRunner = false;
        }
    }
    if (jQuery(carsList).length && carsListAnimationRunner === true) {
        let carsListPosition = carsList.getBoundingClientRect();
        let carsListTop = carsListPosition.top;
        let carsListList = jQuery(carsList).find(".single-car");
        let currentCarsListPoint = 0;

        function recourseCarsListList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).removeClass("before-animation-visibility-backface");
                point++;
                if (point < list.length) recourseCarsListList(list, point);
            }, 150);
        }

        if (windowHeight - carsListTop > 0) {
            jQuery(carsList).find(".default-content-section-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            jQuery(carsList).find(".default-content-section-content").addClass("bottom-side-fade-in").removeClass("before-fade-in");
            recourseCarsListList(carsListList, currentCarsListPoint);
            carsListAnimationRunner = false;
            setTimeout(function () {
                jQuery(carsList).find(".default-content-section-content").removeClass("bottom-side-fade-in").removeClass("before-fade-in");
            }, 2000);
        }
    }
    // END COMMON

    // ABOUT US
    if (jQuery(aboutUsRows).length) {
        for (let i = 0; i < aboutUsRows.length; i++) {
            let currentAboutUsRows = aboutUsRows[i];
            let aboutUsRowsPosition = currentAboutUsRows.getBoundingClientRect();
            let aboutUsRowsPositionTop = aboutUsRowsPosition.top;
            if (windowHeight - aboutUsRowsPositionTop > 0 && aboutUsRowsRunners[i] === true) {
                jQuery(currentAboutUsRows).find(".single-about-us-row-image-self").addClass("bottom-side-fade-in").removeClass("before-fade-in");
                jQuery(currentAboutUsRows).find(".single-about-us-row-title").addClass("left-side-fade-in").removeClass("before-fade-in");
                jQuery(currentAboutUsRows).find(".single-about-us-row-wysiwyg").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
                jQuery(currentAboutUsRows).find(".single-about-us-row-button").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
                aboutUsRowsRunners[i] = false;
                setTimeout(function () {
                    jQuery(currentAboutUsRows).find(".single-about-us-row-wysiwyg").removeClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
                }, 2000);
            }
        }
    }
    if (jQuery(aboutUsMembers).length && aboutUsMembersAnimationRunner === true) {
        let aboutUsMembersPosition = aboutUsMembers.getBoundingClientRect();
        let aboutUsMembersTop = aboutUsMembersPosition.top;
        let aboutUsMembersList = jQuery(aboutUsMembers).find(".single-member");
        let currentAboutUsMembersPoint = 0;

        function recourseAboutUsMembersList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).removeClass("before-animation-visibility-backface");
                point++;
                if (point < list.length) recourseAboutUsMembersList(list, point);
            }, 200);
        }

        if (windowHeight - aboutUsMembersTop > 0) {
            jQuery(aboutUsMembers).find(".about-us-members-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            recourseAboutUsMembersList(aboutUsMembersList, currentAboutUsMembersPoint);
            aboutUsMembersAnimationRunner = false;
        }
    }
    // END ABOUT US

    // CONTACTS
    if (jQuery(contactsColumns).length && contactsColumnsAnimationRunner === true) {
        let contactsColumnsPosition = contactsColumns.getBoundingClientRect();
        let contactsColumnsTop = contactsColumnsPosition.top;
        let contactsColumnsList = jQuery(contactsColumns).find(".contacts-column");
        let currentContactsColumnsPoint = 0;

        function recourseContactsColumnsList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).addClass("bottom-side-fade-in").removeClass("before-fade-in");
                point++;
                if (point < list.length) recourseContactsColumnsList(list, point);
            }, 150);
        }

        if (windowHeight - contactsColumnsTop > 0) {
            recourseContactsColumnsList(contactsColumnsList, currentContactsColumnsPoint);
            contactsColumnsAnimationRunner = false;
        }
    }
    if (jQuery(contactsMaps).length && contactsMapsAnimationRunner === true) {
        let contactsMapsPosition = contactsMaps.getBoundingClientRect();
        let contactsMapsTop = contactsMapsPosition.top;
        let contactsMapsList = jQuery(contactsMaps).find(".single-contact-map");
        let currentContactsMapsPoint = 0;

        function recourseContactsMapsList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).addClass("bottom-side-fade-in").removeClass("before-fade-in");
                point++;
                if (point < list.length) recourseContactsMapsList(list, point);
            }, 250);
        }

        if (windowHeight - contactsMapsTop > 0) {
            jQuery(contactsMaps).find(".contacts-maps-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            recourseContactsMapsList(contactsMapsList, currentContactsMapsPoint);
            contactsMapsAnimationRunner = false;
        }
    }
    // END CONTACTS

    // FAQ
    if (jQuery(faqHeroPartners).length && faqHeroPartnersAnimationRunner === true) {
        let faqHeroPartnersPosition = faqHeroPartners.getBoundingClientRect();
        let faqHeroPartnersTop = faqHeroPartnersPosition.top;
        let faqHeroPartnersList = jQuery(faqHeroPartners).find(".single-hero-partner");
        let currentFaqHeroPartnersPoint = 0;

        function recourseFaqHeroPartnersList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).removeClass("before-animation-visibility-backface");
                point++;
                if (point < list.length) recourseFaqHeroPartnersList(list, point);
            }, 150);
        }

        if (windowHeight - faqHeroPartnersTop > 0) {
            recourseFaqHeroPartnersList(faqHeroPartnersList, currentFaqHeroPartnersPoint);
            faqHeroPartnersAnimationRunner = false;
        }
    }
    if (jQuery(faq).length && faqAnimationRunner === true) {
        let faqPosition = faq.getBoundingClientRect();
        let faqTop = faqPosition.top;
        let faqList = jQuery(faq).find(".accordion-tab");
        let currentFaqPoint = 0;

        function recourseFaqList(list, point) {
            setTimeout(function () {
                let currentIterFaq = jQuery(list[point]);
                currentIterFaq.addClass("right-side-animation-simple");
                setTimeout(function () {
                    currentIterFaq
                        .removeClass("before-animation-left")
                        .removeClass("before-animation-right")
                        .removeClass("left-side-animation-simple")
                        .removeClass("right-side-animation-simple");
                }, 1500);
                point++;

                if (point < list.length) recourseFaqList(list, point);
            }, 200);
        }

        if (windowHeight - faqTop > 0) {
            jQuery(faq).find(".faq-list-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            recourseFaqList(faqList, currentFaqPoint);
            faqAnimationRunner = false;
        }
    }
    // END FAQ

    // HOME
    if (jQuery(homeFilters).length && homeFiltersAnimationRunner === true) {
        let homeFiltersPosition = homeFilters.getBoundingClientRect();
        let homeFiltersTop = homeFiltersPosition.top;
        if (windowHeight - homeFiltersTop > 0) {
            jQuery(homeFilters).find(".home-filters").addClass("bottom-side-fade-in").removeClass("before-fade-in");
            jQuery(homeFilters).find(".calculator-container").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            homeFiltersAnimationRunner = false;
        }
    }
    // END HOME

    // APPLICATION
    if (jQuery(applicationMain).length && applicationMainAnimationRunner === true) {
        let applicationMainPosition = applicationMain.getBoundingClientRect();
        let applicationMainTop = applicationMainPosition.top;
        if (windowHeight - applicationMainTop > 0) {
            jQuery(applicationMain).find(".application-form").addClass("left-side-fade-in").removeClass("before-fade-in");
            jQuery(applicationMain).find(".application-content-wysiwyg").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            applicationMainAnimationRunner = false;
            setTimeout(function () {
                jQuery(applicationMain).find(".application-content-wysiwyg").removeClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            }, 2000);
        }
    }
    if (jQuery(applicationCells).length && applicationCellsAnimationRunner === true) {
        let applicationCellsPosition = applicationCells.getBoundingClientRect();
        let applicationCellsTop = applicationCellsPosition.top;
        let applicationCellsList = jQuery(applicationCells).find(".single-cell");
        let currentApplicationCellsPoint = 0;

        function recourseApplicationCellsList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).removeClass("before-animation-visibility-backface");
                point++;
                if (point < list.length) recourseApplicationCellsList(list, point);
            }, 200);
        }

        if (windowHeight - applicationCellsTop > 0) {
            recourseApplicationCellsList(applicationCellsList, currentApplicationCellsPoint);
            applicationCellsAnimationRunner = false;
        }
    }
    // END APPLICATION

    // SINGLE CAR
    if (jQuery(singleCarDetails).length && singleCarDetailsAnimationRunner === true) {
        let singleCarDetailsPosition = singleCarDetails.getBoundingClientRect();
        let singleCarDetailsTop = singleCarDetailsPosition.top;
        let singleCarDetailsList = jQuery(singleCarDetails).find(".single-car-details-section");
        let currentSingleCarDetailsPoint = 0;

        function recourseSingleCarDetailsList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).addClass("bottom-side-fade-in").removeClass("before-fade-in");
                point++;
                (point < list.length)
                    ? recourseSingleCarDetailsList(list, point)
                    : jQuery(".single-car-details-banner").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            }, 100);
        }

        if (windowHeight - singleCarDetailsTop > 0) {
            jQuery(singleCarDetails).find(".single-car-details-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            recourseSingleCarDetailsList(singleCarDetailsList, currentSingleCarDetailsPoint);
            singleCarDetailsAnimationRunner = false;
        }
    }
    if (jQuery('.single-car-additional-content').length && singleCarAdditionalContentAnimationRunner === true) {
        let additionalInView = false;
        jQuery('.single-car-additional-content').each(function () {
            let top = this.getBoundingClientRect().top;
            if (windowHeight - top > 0) {
                additionalInView = true;
            }
        });
        if (additionalInView) {
            jQuery(".single-car-additional-content-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            jQuery(".single-car-additional-content-wysiwyg").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            jQuery(".single-car-additional-content .wheel-fitments-compact-list").removeClass("before-fade-in");
            jQuery(".wheel-api-fitment-browser, .wheel-api-fitment-search").removeClass("before-fade-in");
            jQuery(".single-car-additional-content .text-muted.small").removeClass("before-fade-in");
            jQuery(".car-compatible-wheels-section").removeClass("before-fade-in");
            singleCarAdditionalContentAnimationRunner = false;
            setTimeout(function () {
                jQuery(".single-car-additional-content-wysiwyg").removeClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            }, 2000);
        }
    }
    if (jQuery(singleCarButtons).length && singleCarButtonsAnimationRunner === true) {
        let singleCarButtonsPosition = singleCarButtons.getBoundingClientRect();
        let singleCarButtonsTop = singleCarButtonsPosition.top;
        let singleCarButtonsList = jQuery(singleCarButtons).find(".single-car-single-button");
        let currentSingleCarButtonsPoint = 0;

        function recourseSingleCarButtonsList(list, point) {
            setTimeout(function () {
                jQuery(list[point]).addClass("bottom-side-fade-in").removeClass("before-fade-in");
                point++;
                if (point < list.length) recourseSingleCarButtonsList(list, point);
            }, 100);
        }

        if (windowHeight - singleCarButtonsTop > 0) {
            jQuery(singleCarButtons).find(".single-car-buttons-title").addClass("left-side-fade-in").removeClass("before-fade-in");
            recourseSingleCarButtonsList(singleCarButtonsList, currentSingleCarButtonsPoint);
            jQuery(singleCarButtons).find(".single-car-app-notice").addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            singleCarButtonsAnimationRunner = false;
        }
    }
    if (jQuery(singleCarCharacteristics).length && singleCarCharacteristicsAnimationRunner === true) {
        let singleCarCharacteristicsPosition = singleCarCharacteristics.getBoundingClientRect();
        let singleCarCharacteristicsTop = singleCarCharacteristicsPosition.top;
        if (windowHeight - singleCarCharacteristicsTop > 0) {
            jQuery(singleCarCharacteristics).find(".single-car-characteristics").addClass("left-side-fade-in").removeClass("before-fade-in");
            jQuery(singleCarCharacteristics).find(".calculator-container").addClass("bottom-side-fade-in").removeClass("before-fade-in");
            singleCarCharacteristicsAnimationRunner = false;
        }
    }
    if (jQuery(singleCarCarousel).length && singleCarCarouselAnimationRunner === true) {
        let singleCarCarouselPosition = singleCarCarousel.getBoundingClientRect();
        let singleCarCarouselTop = singleCarCarouselPosition.top;
        if (windowHeight - singleCarCarouselTop > 0) {
            jQuery(singleCarCarousel).addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            singleCarCarouselAnimationRunner = false;
        }
    }
    if (jQuery(singleCarMarketInsight).length && singleCarMarketInsightAnimationRunner === true) {
        let singleCarMarketInsightPosition = singleCarMarketInsight.getBoundingClientRect();
        let singleCarMarketInsightTop = singleCarMarketInsightPosition.top;
        if (windowHeight - singleCarMarketInsightTop > 0) {
            jQuery(singleCarMarketInsight).addClass("bottom-side-fade-in-small-delay").removeClass("before-fade-in");
            singleCarMarketInsightAnimationRunner = false;
        }
    }
    // END SINGLE CAR

};
window.onscroll();
jQuery(function () {
    setTimeout(function () {
        window.onscroll();
        // Ensure any element that has a fade-in animation class is not stuck with opacity 0 from .before-fade-in
        jQuery(".left-side-fade-in, .bottom-side-fade-in, .bottom-side-fade-in-small-delay").removeClass("before-fade-in");
    }, 100);
});
// END SHOWING ELEMENTS ON SCROLL